import { getAnalytics } from "@tm/insurance/analytics";
import { TextNodeType } from "@tm/isomorphic-utils";
import React, { useEffect } from "react";
import FormattedText from "../FormattedText/FormattedText";
import { ImageComponent } from "../ImageComponent/ImageComponent";
import LandingButton from "../LandingButton/LandingButton";
import { ModalWrapper } from "../ModalWrapper/ModalWrapper";
import {
  BenefitIcon,
  BenefitItem,
  HeaderTitle,
  ModalBody,
} from "./DropOffModal.style";

interface ListItem {
  img: string;
  des: TextNodeType;
}

interface DropOffModalData {
  showOnLand?: string;
  img?: string;
  title?: TextNodeType;
  list?: ListItem[];
  ctaText?: {
    title: TextNodeType;
  };
  bottomsheetId?: string;
}

interface DropOffModalProps {
  data: DropOffModalData;
  isOpen: boolean;
  onClose: () => void;
  onCTAClick?: () => void;
}

export const DropOffModal: React.FC<DropOffModalProps> = ({
  data,
  isOpen,
  onClose,
  onCTAClick,
}) => {
  if (!data) return null;
  const analytics = getAnalytics();
  const bottomsheetId = data?.bottomsheetId || "education";

  useEffect(() => {
    analytics?.trackCommonLandingEvents({
      actionType: `${bottomsheetId}_bottomsheet_seen`,
    });
  }, []);
  const ctaText =
    typeof data?.ctaText?.title?.text === "object" &&
    !Array.isArray(data?.ctaText?.title?.text)
      ? data.ctaText.title.text.value
      : "EXPLORE INSURANCE";
  return (
    <ModalWrapper isOpen={isOpen} onClose={onClose}>
      {data?.img && (
        <ImageComponent
          src={data.img}
          width="500px"
          height="auto"
          alt="Travel Safety"
        />
      )}
      <ModalBody>
        {data?.title && (
          <HeaderTitle>
            <FormattedText value={data.title} />
          </HeaderTitle>
        )}

        {data?.list?.map((item, index) => (
          <BenefitItem key={index}>
            <BenefitIcon>
              <ImageComponent
                src={item.img}
                width="48px"
                height="48px"
                alt={`Benefit ${index + 1}`}
              />
            </BenefitIcon>
            <FormattedText value={item.des} />
          </BenefitItem>
        ))}

        <LandingButton
          customTitle={ctaText}
          onClick={() => {
            analytics?.trackCommonLandingEvents({
              actionType: `${bottomsheetId}_primary_cta_clicked`,
            });
            onCTAClick?.();
          }}
          customWidth="100%"
        />
      </ModalBody>
    </ModalWrapper>
  );
};

export default DropOffModal;
